import { html, nothing } from 'lit';
import { ConnectProductsController } from '../../lib/controllers/connect-products.js';
import { request } from '../../lib/request.js';
import { BaseElement } from '../base.js';

export class ConnectAccountProducts extends BaseElement {
  static properties = {
    account: { attribute: true },
    item: {}
  };

  constructor() {
    super();
    this.account = '';
    this.products = new ConnectProductsController(this);
    this.downloading = false;
    this.filename = '';
  }

  async onDownload() {
    this.downloading = true;
    this.requestUpdate();

    const { url, filename } = await request(
      'GET',
      `/connect-accounts/${this.account}/products/download`
    );

    this.filename = filename;
    this.downloading = false;
    this.requestUpdate();

    location.href = url;
  }

  render() {
    return this.products.render(({ total }) => {
      return html`
        <div>Account has <strong>${total}</strong> items.</div>
        ${total
          ? html`<div class="mt-2">${this.renderAction()}</div>`
          : nothing}
      `;
    });
  }

  renderAction() {
    if (this.downloading) {
      return html`<div class="spinner-border spinner-border-sm"></div>`;
    }

    const icon = this.filename ? 'bi-check-circle' : 'bi-download';

    return html`
      <button
        class="btn btn-primary btn-sm ${this.filename && 'btn-success'}"
        ?disabled=${this.filename}
        @click=${this.onDownload}
      >
        <i class="bi ${icon}"></i> ${this.filename
          ? `Downloaded ${this.filename}`
          : 'Download as CSV'}
      </button>
    `;
  }
}

customElements.define('connect-account-products', ConnectAccountProducts);
